var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Office50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#90caf9",
    d: "M6,37h26V7c0-1.1-0.9-2-2-2H8C6.9,5,6,5.9,6,7V37z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#64b5f6",
    d: "M32,37H6v2h26V37z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1565c0",
    d: "M21 31h-4v4h4V31zM14 31h-4v4h4V31zM21 17h-4v4h4V17zM14 17h-4v4h4V17zM21 24h-4v4h4V24zM14 24h-4v4h4V24zM21 10h-4v4h4V10zM28 10h-4v4h4V10zM14 10h-4v4h4V10z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e88e5",
    d: "M40,17H25c-1.1,0-2,0.9-2,2v22h19V19C42,17.9,41.1,17,40,17z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M23 41H42V43H23z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0d47a1",
    d: "M31 21h-4v4h4V21zM31 28h-4v4h4V28zM31 35h-4v4h4V35zM34 28h4v4h-4V28zM34 35h4v4h-4V35zM38 21h-4v4h4V21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Office50);
export default __webpack_public_path__ + "static/media/icons8-office-50.db0524417096322eadeaa10fd772cdd7.svg";
export { ForwardRef as ReactComponent };